import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { useTranslation } from 'react-i18next'
import { ClientLocaleNS } from 'lib/constants/locales'
import { PrivacyPageContent } from 'client/contents/PrivacyPageContent/PrivacyPageContent'

type TProps = {}

const PrivacyPage: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.PrivacyPage)
  return (
    <article className="bg-surface-white flex h-full w-full flex-col">
      <AppHead title={t('title')} />
      <PrivacyPageContent />
    </article>
  )
}

export default PrivacyPage
